<template>
  <div class="account-appeal-index">
    <h3>账号申诉</h3>
    <p>请输入申诉的手机号码</p>

    <div class="second-phone-form">
      <input
        type="tel"
        maxlength="15"
        @input="inputChange"
        v-model="userPhone"
        placeholder="请输入申诉的手机号码"
      />
      <span v-show="isCanNext">下一步</span>
      <span
        v-show="!isCanNext"
        style="background-color: #1789f9"
        @click="onSubmit"
        >下一步</span
      >
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { request } from "../../utils/request.js";
import { encryptByAES, encryptKey } from "../../api/encryption.js";
export default {
  data() {
    return {
      userPhone: "",
      isCanNext: true,
    };
  },
  methods: {
    onSubmit(values) {
      let loginName = this.userPhone.split(" ")[1];
      let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(loginName)) {
        this.JSBridge.toast("请输入正确的手机号!");
        return;
      }
      // this.JSBridge.showLoading("数据加载中..");
      request({
        url: "/sga/user/findPsnInfoByPhoneStepOne",
        type: "post",
        params: {
          loginName: encryptByAES(loginName, encryptKey),
          idcard: "",
          bankcard: "",
        },
      })
        // this.JSBridge.requestRpc({
        //     url: "com.abchina.xyl.findPsnInfoByPhoneStepOne",
        //     params: {
        //         loginName: loginName,
        //     }
        // })
        .then((res) => {
          console.log("验证手机号");
          console.log(res);
          // this.JSBridge.hideLoading();
          if (res.respCode == "00000000") {
            let data = { phone: loginName };
            this.$router.push({
              path: "/accountAppeal/therePhone",
              query: data,
            });
          } else {
            Dialog.alert({
              message: res.respMsg,
            });
          }
        })
        .catch((error) => {
          // this.JSBridge.hideLoading();
          console.log(error);
        });
      // this.$router.push({ path: path})
      // console.log('submit', values);
    },
    inputIsPhone() {},
    inputChange(e) {
      let value = e.target.value;
      let result = value.split(" ");
      if (value != "+86 ") {
        if (value && result[1] == undefined) {
          this.isCanNext = false;
          this.userPhone = "+86 " + result[0];
        } else if (value && result[1] != undefined) {
          this.isCanNext = false;
          this.userPhone = "+86 " + result[1];
        } else {
          this.isCanNext = true;
          this.userPhone = "";
        }
      } else {
        this.isCanNext = true;
        this.userPhone = "";
      }
    },
  },
};
</script>

<style scoped lang="less">
.account-appeal-index {
  background-color: #ffffff;
  height: 100%;
  padding: 20px 20px 0px 20px;
  box-sizing: border-box;
}
.account-appeal-index h3 {
  font-size: 0.7rem;
  color: #287bac;
  margin-bottom: 5px;
  font-weight: 400;
}
.account-appeal-index p {
  font-size: 0.35rem;
  color: #999999;
  letter-spacing: 1.5px;
  margin-top: 10px;
}
.second-phone-form {
  margin-top: 25%;
  input {
    width: 100%;
    height: 40px;
    line-height: 25px;
    border: none;
    border-bottom: thin solid #e8e9ed;
    font-size: 0.4rem;
    border-radius: 0;
  }
  span {
    width: 100%;
    height: 50px;
    line-height: 50px;
    margin-top: 20px;
    background-color: #8ec3fd;
    display: block;
    color: #ffffff;
    text-align: center;
    font-size: 0.45rem;
    border-radius: 3px;
  }
  .activity {
    background-color: #1789f9;
  }
}
.from-field-phone {
  width: 100%;
  font-size: 0.45rem;
  padding-bottom: 10px;
  color: #999999;
}
.from-button {
  width: 100%;
  border-radius: 5px;
  button {
    border-radius: 3px;
    margin-top: 20px;
    height: 50px;
  }
}
</style>
